var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.282,
    height: 40.175,
    viewBox: "0 0 44.282 40.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 44.282,
    height: 40.175,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M43.349,29.846,28.1,3.443A6.815,6.815,0,0,0,22.142,0h0a6.814,6.814,0,0,0-5.963,3.443L.934,29.846A6.886,6.886,0,0,0,6.9,40.175H37.385a6.886,6.886,0,0,0,5.964-10.329m-5.964,5.683H6.9a2.24,2.24,0,0,1-1.939-3.359L20.2,5.766a2.239,2.239,0,0,1,3.878,0l15.244,26.4a2.24,2.24,0,0,1-1.94,3.359",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M48.494,65.671a2.221,2.221,0,0,0-1.638.7,2.31,2.31,0,0,0-.681,1.67,2.268,2.268,0,0,0,.683,1.66,2.242,2.242,0,0,0,1.636.683,2.317,2.317,0,0,0,1.671-.68,2.252,2.252,0,0,0,.7-1.663,2.375,2.375,0,0,0-2.369-2.368",
    transform: "translate(-26.365 -38.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M46.821,40.82h3.12l.846-12.409H45.974Z",
    transform: "translate(-26.239 -15.19)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3b3d0046e68e7ef74b6a7f6124f821e3.svg";
export { ForwardRef as ReactComponent };